var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1152.869 657.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modal_background",
    "data-name": "Modal background",
    transform: "translate(-18041.793 -1483.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8560",
    "data-name": "Path 8560",
    d: "M153.936,767.852l-21.4,37.062h85.591l-21.4-37.062-21.4-37.063Z",
    transform: "translate(18166.027 1261.84)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8579",
    "data-name": "Path 8579",
    d: "M208.157,787.639l-21.4,37.063-21.4,37.062h85.59l-21.4-37.062-21.4-37.063Z",
    transform: "translate(18176 1279.111)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8580",
    "data-name": "Path 8580",
    d: "M142.509,787.639l-21.4,37.063-21.4,37.062H185.3l-21.4-37.062-21.4-37.063Z",
    transform: "translate(18156.055 1279.111)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8581",
    "data-name": "Path 8581",
    d: "M76.865,787.639,55.467,824.7l-21.4,37.062h85.59L98.263,824.7l-21.4-37.063Z",
    transform: "translate(18136.111 1279.111)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8588",
    "data-name": "Path 8588",
    d: "M131.087,824.7l21.4-37.062H66.894L88.29,824.7l21.4,37.063Z",
    transform: "translate(18146.082 1279.111)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8589",
    "data-name": "Path 8589",
    d: "M175.335,861.764l21.4-37.063,21.4-37.062H132.539l21.4,37.062,21.4,37.063Z",
    transform: "translate(18166.027 1279.111)",
    fill: "#d9d9d9",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8590",
    "data-name": "Path 8590",
    d: "M262.379,824.7l21.4-37.062h-85.59l21.4,37.062,21.4,37.063Z",
    transform: "translate(18185.971 1279.111)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8595",
    "data-name": "Path 8595",
    d: "M88.286,767.849,66.893,804.915h85.59l-21.4-37.062-21.4-37.063Z",
    transform: "translate(18146.084 1261.84)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8596",
    "data-name": "Path 8596",
    d: "M22.641,767.849l-21.4,37.061H86.835L65.441,767.852l-21.4-37.063Z",
    transform: "translate(18126.139 1261.84)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8600",
    "data-name": "Path 8600",
    d: "M350.874,767.852l-21.4,37.062h85.591l-21.4-37.062-21.4-37.063Z",
    transform: "translate(18225.859 1261.84)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8602",
    "data-name": "Path 8602",
    d: "M163.909,767.847l21.4-37.062H99.715l21.4,37.062,21.4,37.063Z",
    transform: "translate(18156.055 1261.838)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8607",
    "data-name": "Path 8607",
    d: "M32.614,767.847l21.4-37.062H-31.58l21.4,37.062,21.4,37.063Z",
    transform: "translate(18116.166 1261.838)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8608",
    "data-name": "Path 8608",
    d: "M76.865,804.915l21.4-37.065,21.4-37.061H34.07l21.4,37.057,21.4,37.063Z",
    transform: "translate(18136.111 1261.84)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8609",
    "data-name": "Path 8609",
    d: "M142.509,673.934,121.112,711l-21.4,37.061H185.3L163.909,711l-21.4-37.065Z",
    transform: "translate(18156.055 1244.566)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8610",
    "data-name": "Path 8610",
    d: "M76.865,673.934,55.467,711l-21.4,37.061h85.59L98.263,711l-21.4-37.065Z",
    transform: "translate(18136.111 1244.566)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8611",
    "data-name": "Path 8611",
    d: "M-10.182,711l-21.4,37.061h85.59L32.615,711l-21.4-37.065Z",
    transform: "translate(18116.166 1244.566)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8613",
    "data-name": "Path 8613",
    d: "M383.7,711l-21.4,37.061h85.59L426.494,711l-21.4-37.065Z",
    transform: "translate(18235.83 1244.566)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8616",
    "data-name": "Path 8616",
    d: "M131.087,711l21.4-37.062H66.894L88.29,711l21.4,37.063Z",
    transform: "translate(18146.082 1244.566)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8617",
    "data-name": "Path 8617",
    d: "M175.335,748.059,196.733,711l21.4-37.062H132.539L153.937,711l21.4,37.063Z",
    transform: "translate(18166.027 1244.566)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8618",
    "data-name": "Path 8618",
    d: "M262.379,711l21.4-37.062h-85.59L219.581,711l21.4,37.063Z",
    transform: "translate(18185.971 1244.566)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8620",
    "data-name": "Path 8620",
    d: "M372.273,748.059,393.671,711l21.4-37.062H329.477L350.875,711l21.4,37.063Z",
    transform: "translate(18225.859 1244.566)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8622",
    "data-name": "Path 8622",
    d: "M-.206,711l21.4-37.062H-64.4L-43,711l21.4,37.063Z",
    transform: "translate(18106.195 1244.566)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8623",
    "data-name": "Path 8623",
    d: "M44.038,748.059,65.436,711l21.4-37.062H1.247L22.644,711l21.4,37.063Z",
    transform: "translate(18126.141 1244.566)",
    fill: "#d9d9d9",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8624",
    "data-name": "Path 8624",
    d: "M240.98,617.081l-21.4,37.065-21.4,37.061h85.59l-21.4-37.061-21.4-37.065Z",
    transform: "translate(18185.971 1227.294)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8625",
    "data-name": "Path 8625",
    d: "M175.334,617.081l-21.4,37.065-21.4,37.061h85.591l-21.4-37.061-21.4-37.065Z",
    transform: "translate(18166.027 1227.294)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8626",
    "data-name": "Path 8626",
    d: "M109.684,617.081l-21.4,37.063L66.893,691.206h85.59l-21.4-37.061-21.4-37.065Z",
    transform: "translate(18146.084 1227.294)",
    fill: "#d9d9d9",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8627",
    "data-name": "Path 8627",
    d: "M44.039,617.081l-21.4,37.063-21.4,37.061H86.835l-21.394-37.06-21.4-37.065Z",
    transform: "translate(18126.139 1227.294)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8628",
    "data-name": "Path 8628",
    d: "M-21.607,617.081l-21.4,37.065-21.4,37.061H21.192l-21.4-37.061-21.4-37.065Z",
    transform: "translate(18106.195 1227.294)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8633",
    "data-name": "Path 8633",
    d: "M163.909,654.142l21.4-37.061H99.715l21.4,37.061,21.4,37.063Z",
    transform: "translate(18156.055 1227.294)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8634",
    "data-name": "Path 8634",
    d: "M208.157,691.205l21.4-37.063,21.4-37.061h-85.59l21.4,37.061,21.4,37.063Z",
    transform: "translate(18176 1227.294)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8640",
    "data-name": "Path 8640",
    d: "M32.614,654.142l21.4-37.061H-31.58l21.4,37.061,21.4,37.063Z",
    transform: "translate(18116.166 1227.294)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8641",
    "data-name": "Path 8641",
    d: "M76.865,691.205l21.4-37.063,21.4-37.061H34.07l21.4,37.061,21.4,37.063Z",
    transform: "translate(18136.111 1227.294)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8645",
    "data-name": "Path 8645",
    d: "M-10.182,597.291l-21.4,37.061h85.59l-21.4-37.061-21.4-37.063Z",
    transform: "translate(18116.166 1210.021)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8560-2",
    "data-name": "Path 8560",
    d: "M21.4,37.063,0,74.126H85.591l-21.4-37.062L42.795,0Z",
    transform: "translate(18937.891 1631.822) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8579-2",
    "data-name": "Path 8579",
    d: "M42.795,0,21.4,37.063,0,74.125H85.59l-21.4-37.062L42.794,0Z",
    transform: "translate(18895.094 1557.701) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8580-2",
    "data-name": "Path 8580",
    d: "M42.794,0,21.4,37.063,0,74.125H85.59l-21.4-37.062L42.795,0Z",
    transform: "translate(18980.686 1557.701) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8581-2",
    "data-name": "Path 8581",
    d: "M42.795,0,21.4,37.063,0,74.125H85.59l-21.4-37.062L42.794,0Z",
    transform: "translate(19066.273 1557.701) rotate(180)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8588-2",
    "data-name": "Path 8588",
    d: "M64.193,37.062,85.59,0H0L21.4,37.062l21.4,37.063Z",
    transform: "translate(19023.479 1557.701) rotate(180)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8589-2",
    "data-name": "Path 8589",
    d: "M42.8,74.125l21.4-37.063L85.591,0H0L21.4,37.062,42.8,74.125Z",
    transform: "translate(18937.889 1557.701) rotate(180)",
    fill: "#d9d9d9",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8590-2",
    "data-name": "Path 8590",
    d: "M64.193,37.062,85.59,0H0L21.4,37.062l21.4,37.063Z",
    transform: "translate(18852.299 1557.701) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8595-2",
    "data-name": "Path 8595",
    d: "M21.393,37.059,0,74.126H85.59l-21.4-37.062L42.794,0Z",
    transform: "translate(19023.479 1631.822) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8596-2",
    "data-name": "Path 8596",
    d: "M21.4,37.059,0,74.12H85.591L64.2,37.063,42.8,0Z",
    transform: "translate(19109.072 1631.822) rotate(180)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8600-2",
    "data-name": "Path 8600",
    d: "M21.4,37.063,0,74.126H85.591l-21.4-37.062L42.795,0Z",
    transform: "translate(18681.119 1631.822) rotate(180)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8601",
    "data-name": "Path 8601",
    d: "M21.4,37.063,0,74.126H85.59l-21.4-37.062L42.794,0Z",
    transform: "translate(18766.709 1631.822) rotate(180)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8602-2",
    "data-name": "Path 8602",
    d: "M64.194,37.062,85.591,0H0L21.4,37.062,42.8,74.126Z",
    transform: "translate(18980.686 1631.828) rotate(180)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8603",
    "data-name": "Path 8603",
    d: "M64.193,37.062,85.59,0H0L21.4,37.062l21.4,37.063Z",
    transform: "translate(18809.504 1631.828) rotate(180)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8604",
    "data-name": "Path 8604",
    d: "M42.8,74.126l21.4-37.063L85.591,0H0L21.4,37.062,42.8,74.126Z",
    transform: "translate(18723.914 1631.828) rotate(180)",
    fill: "#d9d9d9",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8605",
    "data-name": "Path 8605",
    d: "M42.795,74.126l21.4-37.065L85.59,0H0L21.4,37.057,42.8,74.12Z",
    transform: "translate(18638.324 1631.822) rotate(180)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8607-2",
    "data-name": "Path 8607",
    d: "M64.194,37.062,85.591,0H0L21.4,37.062,42.8,74.126Z",
    transform: "translate(19151.869 1631.828) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8608-2",
    "data-name": "Path 8608",
    d: "M42.795,74.126l21.4-37.065L85.59,0H0L21.4,37.057,42.8,74.12Z",
    transform: "translate(19066.273 1631.822) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8609-2",
    "data-name": "Path 8609",
    d: "M42.794,0,21.4,37.065,0,74.125H85.59l-21.4-37.061L42.795,0Z",
    transform: "translate(18980.686 1705.95) rotate(180)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8610-2",
    "data-name": "Path 8610",
    d: "M42.795,0,21.4,37.065,0,74.125H85.59l-21.4-37.061L42.794,0Z",
    transform: "translate(19066.273 1705.95) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8611-2",
    "data-name": "Path 8611",
    d: "M21.4,37.065,0,74.125H85.59l-21.4-37.061L42.795,0Z",
    transform: "translate(19151.867 1705.95) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8613-2",
    "data-name": "Path 8613",
    d: "M21.4,37.065,0,74.125H85.59l-21.4-37.061L42.794,0Z",
    transform: "translate(18638.324 1705.95) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8614",
    "data-name": "Path 8614",
    d: "M42.795,0,21.4,37.065,0,74.125H85.591l-21.4-37.061L42.795,0Z",
    transform: "translate(18723.914 1705.95) rotate(180)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8615",
    "data-name": "Path 8615",
    d: "M21.4,37.065,0,74.125H85.59l-21.4-37.061L42.794,0Z",
    transform: "translate(18809.504 1705.95) rotate(180)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8616-2",
    "data-name": "Path 8616",
    d: "M64.193,37.062,85.59,0H0L21.4,37.062l21.4,37.063Z",
    transform: "translate(19023.479 1705.95) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8617-2",
    "data-name": "Path 8617",
    d: "M42.8,74.125l21.4-37.063L85.591,0H0L21.4,37.062,42.8,74.125Z",
    transform: "translate(18937.889 1705.95) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8618-2",
    "data-name": "Path 8618",
    d: "M64.193,37.062,85.59,0H0L21.4,37.062l21.4,37.063Z",
    transform: "translate(18852.299 1705.95) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8619",
    "data-name": "Path 8619",
    d: "M64.194,37.062,85.59,0H0L21.4,37.062,42.8,74.125Z",
    transform: "translate(18766.709 1705.95) rotate(180)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8620-2",
    "data-name": "Path 8620",
    d: "M42.8,74.125l21.4-37.063L85.591,0H0L21.4,37.062,42.8,74.125Z",
    transform: "translate(18681.119 1705.95) rotate(180)",
    fill: "#008843",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8622-2",
    "data-name": "Path 8622",
    d: "M64.194,37.062,85.591,0H0L21.4,37.062,42.8,74.125Z",
    transform: "translate(19194.66 1705.95) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8623-2",
    "data-name": "Path 8623",
    d: "M42.791,74.125l21.4-37.063L85.587,0H0L21.4,37.062,42.8,74.125Z",
    transform: "translate(19109.068 1705.95) rotate(180)",
    fill: "#d9d9d9",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8624-2",
    "data-name": "Path 8624",
    d: "M42.795,0,21.4,37.065,0,74.126H85.59l-21.4-37.061L42.794,0Z",
    transform: "translate(18852.299 1780.076) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8625-2",
    "data-name": "Path 8625",
    d: "M42.8,0,21.4,37.065,0,74.126H85.591l-21.4-37.061L42.795,0Z",
    transform: "translate(18937.891 1780.076) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8626-2",
    "data-name": "Path 8626",
    d: "M42.791,0l-21.4,37.063L0,74.126H85.59l-21.4-37.061L42.794,0Z",
    transform: "translate(19023.479 1780.076) rotate(180)",
    fill: "#d9d9d9",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8627-2",
    "data-name": "Path 8627",
    d: "M42.795,0,21.4,37.063,0,74.124H85.591L64.2,37.065,42.8,0Z",
    transform: "translate(19109.072 1780.076) rotate(180)",
    fill: "#56aa32",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8628-2",
    "data-name": "Path 8628",
    d: "M42.795,0,21.4,37.065,0,74.126H85.594L64.2,37.065,42.8,0Z",
    transform: "translate(19194.662 1780.076) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8633-2",
    "data-name": "Path 8633",
    d: "M64.194,37.061,85.591,0H0L21.4,37.061,42.8,74.124Z",
    transform: "translate(18980.686 1780.076) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8634-2",
    "data-name": "Path 8634",
    d: "M42.795,74.124l21.4-37.063L85.59,0H0L21.4,37.061,42.8,74.124Z",
    transform: "translate(18895.094 1780.076) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8640-2",
    "data-name": "Path 8640",
    d: "M64.194,37.061,85.591,0H0L21.4,37.061,42.8,74.124Z",
    transform: "translate(19151.869 1780.076) rotate(180)",
    fill: "#fff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8641-2",
    "data-name": "Path 8641",
    d: "M42.795,74.124l21.4-37.063L85.59,0H0L21.4,37.061,42.8,74.124Z",
    transform: "translate(19066.273 1780.076) rotate(180)",
    fill: "none",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8645-2",
    "data-name": "Path 8645",
    d: "M21.4,37.063,0,74.124H85.59l-21.4-37.061L42.795,0Z",
    transform: "translate(19151.867 1854.201) rotate(180)",
    fill: "#008843",
    opacity: 0.16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBackground);
export default __webpack_public_path__ + "static/media/modal-background.6377d5234ac45a378386e1779df9e6ab.svg";
export { ForwardRef as ReactComponent };